module.exports = __webpack_public_path__ + "img/home-nav-icon-3.8597cc70.png";